import axios from "@/api/axios";

function getNews(params) {
  return axios.get("services/v1.0/manageorganization/news/", { params });
}

export default {
  getNews
};
